import Logger from "../lib/logger";

/**
 * Tracker --- A static class for tracking events for analytics
 * @author Vincent V. Toscano
 */
class Tracker {
	static NAME = 'TRACKER';

	static trackEvent(event = 'search', obj) {
		console.group(`${Tracker.NAME} > trackEvent`);
		console.log(`${Tracker.NAME} > trackEvent > ${event}`);

		let tracking_obj;

		switch (event) {
			case "search":
				/**
				 * Build tracking object
				 */
				tracking_obj = {
					...(obj.search_term) && {search_term: obj.search_term},
					...(obj.search_job_type) && {search_job_type: obj.search_job_type},
					...(obj.search_location) && {search_location: obj.search_location}
				};
				if (!obj.search_term) console.error(`${Tracker.NAME} > trackEvent > Missing required tracking event property: ${event}.`);
				else {
					gtag('event', event, tracking_obj);
					console.info(`${Tracker.NAME} > trackEvent >`, event, tracking_obj);
				}
				break;
			case "careers_apply_specialty_only":
				/**
				 * Build tracking object
				 */
				tracking_obj = {
					...(obj.careers_apply_specialty) && {careers_apply_specialty: obj.careers_apply_specialty},
				};

				if (!obj.careers_apply_specialty) console.error(`${Tracker.NAME} > onTrack > Missing required tracking event property: ${event}.`);
				else {
					gtag('event', event, tracking_obj);
					console.info(`${Tracker.NAME} > onTrack >`, event, tracking_obj);
				}
				break;
			case "article_page_view":
				/**
				 * Build tracking object
				 */
				tracking_obj = {
					...(obj.article_id) && {article_id: obj.article_id},
					...(obj.article_url) && {article_url: obj.article_url},
				};

				if (!obj.article_id) console.error(`${Tracker.NAME} > onTrack > Missing required tracking event property: ${event}.`);
				else {
					gtag('event', event, tracking_obj);
					console.info(`${Tracker.NAME} > onTrack >`, event, tracking_obj);
				}
				break;
			default:
				console.error(`${Tracker.NAME} > trackEvent > Missing case for tracking event.`);
		}
		console.groupEnd();
	}

	static onTrack(evt) {
		console.group(`${Tracker.NAME} > trackEvent`);
		const target = evt.target,
		      event = target.getAttribute('data-ga-evt');
		let tracking_obj;
		console.log(`${Tracker.NAME} > onTrack > event = ${event} | target = ${target} | nodeName= ${target.nodeName}`);

		if ((target && target.nodeName === "BUTTON" || target.nodeName === "A" || target.nodeName === "MAIN" || target.nodeName === "VIDEO") && event) {

			switch (event) {
				case "careers_apply":
				case "careers_view_position_details":
					/**
					 * Build tracking object
					 */
					tracking_obj = {
						...(target.getAttribute('data-ga-job-type')) && {careers_apply_job_type: target.getAttribute('data-ga-job-type')},
						...(target.getAttribute('data-ga-family-department')) && {careers_apply_family_department: target.getAttribute('data-ga-family-department')},
						...(target.getAttribute('data-ga-location')) && {careers_apply_location: target.getAttribute('data-ga-location')}
					};

					if (!target.getAttribute('data-ga-job-type')) console.error(`${Tracker.NAME} > onTrack > Missing required tracking event property: ${event}.`);
					else {
						gtag('event', event, tracking_obj);
						console.info(`${Tracker.NAME} > onTrack >`, event, tracking_obj);
					}
					break;
				case "careers_apply_specialty_only":
					/**
					 * Build tracking object
					 */
					tracking_obj = {
						...(target.getAttribute('data-ga-specialty')) && {careers_apply_specialty: target.getAttribute('data-ga-specialty')},
					};

					if (!target.getAttribute('data-ga-specialty')) console.error(`${Tracker.NAME} > onTrack > Missing required tracking event property: ${event}.`);
					else {
						gtag('event', event, tracking_obj);
						console.info(`${Tracker.NAME} > onTrack >`, event, tracking_obj);
					}
					break;
				case "careers_quiz_results_learn_more":
					/**
					 * Build tracking object
					 */
					tracking_obj = {
						...(target.getAttribute('data-ga-heading-1')) && {careers_heading_1: target.getAttribute('data-ga-heading-1')},
						...(target.getAttribute('data-ga-heading-2')) && {careers_heading_2: target.getAttribute('data-ga-heading-2')},
						...(target.getAttribute('data-ga-article-url')) && {careers_article_url: target.getAttribute('data-ga-article-url')}
					};

					if (!target.getAttribute('data-ga-heading-1')) console.error(`${Tracker.NAME} > onTrack > Missing required tracking event property: ${event}.`);
					else {
						gtag('event', event, tracking_obj);
						console.info(`${Tracker.NAME} > onTrack >`, event, tracking_obj);
					}
					break;
				default:
					console.error(`${Tracker.NAME} > onTrack > Missing case for tracking event.`);
			}
		}
		console.groupEnd();
	}


	/**
	 * Class static initialization block
	 */
	static {
		Logger.info(`${this.NAME} > init`);
		document.body.addEventListener('mousedown', Tracker.onTrack);
	}
}

export default Tracker;
